import { render, staticRenderFns } from "./ComponentTickSpread.vue?vue&type=template&id=00762392"
import script from "./ComponentTickSpread.vue?vue&type=script&lang=js"
export * from "./ComponentTickSpread.vue?vue&type=script&lang=js"
import style0 from "./ComponentTickSpread.vue?vue&type=style&index=0&id=00762392&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports